import { environment } from '@env/environment'
import { Settings } from 'luxon'
// import { Locale } from 'date-fns'
// import { enGB } from 'date-fns/locale'

export const INITIAL_LOCALE: string = environment.locale
export const SET_LOCALE = (locale: string): void => {
  Settings.defaultLocale = locale
  document.documentElement.setAttribute('lang', locale)
}
export const GET_LOCALE = (): string => Settings.defaultLocale
